import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './perform-risk-assessment-dialog.controller';
import template from './perform-risk-assessment-dialog.html';
import updateFrequencyConfirmDialog from '../dialog.updateFrequencyConfirmDialog';

class dialogService {
  getOptions($event, { vendor, product, riskCategories }) {
    return {
      controller,
      controllerAs: 'performRiskAssessmentDialogVM',
      locals: {
        vendor,
        product,
        riskCategories,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.performRiskAssessmentDialog', [
  alerts,
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
  updateFrequencyConfirmDialog,
])
  .service('performRiskAssessmentDialog', dialogService)
  .name;
